<div class="date-container">
    <label class="date-label">{{labelText}}</label>
    <input class="input" [(ngModel)]="dateModel" [placeholder]="placeholder" [required]="required" 
        [ngClass]="{'input__invalid': !validate()}" (ngModelChange)="onChange($event)" [matDatepicker]="picker">
    <label class="warning-label" *ngIf="submitted && warningLabel && !validate">{{warningLabel}}</label>
    <mat-datepicker-toggle class="date-picker--toggle" matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</div>